import { EditorContent, useEditor, type JSONContent } from '@tiptap/react';
import { useEffect } from 'react';
import { createBoardExtensions } from './editorExtensions.ts';

interface PostViewerProps {
  content: JSONContent;
}

/**
 * 저장된 본문(Tiptap JSON)을 읽기 전용으로 렌더.
 *
 * 같은 extension 을 editable=false 로 재사용한다 → 작성 시와 100% 동일한 렌더.
 * dangerouslySetInnerHTML 로 HTML 을 직접 주입하지 않으므로 XSS 표면이 작다
 * (Tiptap 이 화이트리스트 노드/마크만 렌더). 링크는 extension 설정에서
 * rel/target 이 강제되어 javascript: 스킴 등도 차단된다.
 * 본문 스타일은 에디터와 같은 `.board-content`(index.css)다.
 */
export function PostViewer({ content }: PostViewerProps) {
  const editor = useEditor({
    extensions: createBoardExtensions(),
    content,
    editable: false,
  });

  // 상세 → 다른 상세로 이동 등으로 content 가 바뀌면 갱신
  useEffect(() => {
    if (editor && content) {
      editor.commands.setContent(content);
    }
  }, [editor, content]);

  if (!editor) return null;

  return (
    <EditorContent
      editor={editor}
      className="board-content"
    />
  );
}
